import { createFileRoute } from "@tanstack/react-router";

/**
 * Old `/transaction-monitoring/...` links. The parent route redirects every
 * one of them to the matching `/compliance/...` page before this renders.
 */
export const Route = createFileRoute(
  "/(app)/_main-layout/_transaction-monitoring/transaction-monitoring/$",
)({
  component: () => null,
});
